import React from "react";
import MaterialButton from "@mui/material/Button"
import "./Button.css"
import { CircularProgress } from "@mui/material";

interface Props {
    onClick: () => void,
    className?: string,
    secondary?: boolean,
    outlined?: boolean,
    transparent?: boolean,
    full_width?: boolean,
    icon_top?: boolean,
    disabled?: boolean,
    loading?: boolean,
    icon?: boolean,
    style?: React.CSSProperties,
    children: React.ReactNode
}

const Button: React.FunctionComponent<Props> = (props) => {

    let className = props.className ? props.className + " " : ""

    if (props.secondary)
        className += "secondary ";

    if (props.outlined)
        className += "outlined ";

    if (props.transparent)
        className += " transparent ";

    if (props.full_width)
        className += " full_width ";


    let classNameContent = " "

    if (props.icon)
        classNameContent += " with-icon ";

    if (props.icon_top)
        classNameContent += " icon_button_top ";

    if (props.transparent)
        classNameContent += " transparent ";

    return (
        <MaterialButton style={props.style} disabled={props.disabled} className={"material_button " + className} onClick={props.onClick}>
            <div className={"label " + classNameContent}>
                {
                    props.loading ?
                        <CircularProgress size={18} className={"loading-icon"} />
                        :
                        props.children
                }

            </div>
        </MaterialButton>
    )
}

export default Button;